import { ofType, combineEpics } from 'redux-observable';
import get from 'lodash/get';

import { of } from 'rxjs';
import { map, mergeMap, tap, filter, ignoreElements } from 'rxjs/operators';

import { epics as formRenderer } from 'common/compounds/FormRenderer';

import {
    SUCCESS_REQUEST_SUBMISSION,
    GA_FORM_SUCCESSFULLY_FINISHED_EFFECT,
    GA_FORM_START_EFFECT,
    GA_FORM_ERROR_EFFECT,
} from 'common/compounds/FormRenderer/constants/epicTypes';
import { setGuestAccessHash, setIsUpdating } from 'common/compounds/FormRenderer/actions';

import publishToPreWebpackWorld, { EVENT_FORM_RENDERER_SUBMIT_SUCCESS } from 'utils/publishToPreWebpackWorld';

import { closeModal, getFormStarted, setFormStarted, setFormCompleted, getIsUserLoggedIn } from './splashPage';

const GA4_EVENT_CATEGORY_RSVP = 'rsvp';
const GA4_FORM_STARTED = 'form_started';
const GA4_FORM_SUBMITTED = 'form_submitted';
const GA4_FORM_ERROR = 'form_error';

export const onSubmitCloseModalEpic = (action$, state$) =>
    action$.pipe(
        ofType(SUCCESS_REQUEST_SUBMISSION),
        tap(({ meta: { response, params } }) =>
            publishToPreWebpackWorld(EVENT_FORM_RENDERER_SUBMIT_SUCCESS, {
                response,
                params,
            }),
        ),
        mergeMap(({ meta: { response } }) => of(closeModal(), setGuestAccessHash(response.guestAccessHash))),
    );

export const onUpdatedSubmissionEpic = (action$, state$) =>
    action$.pipe(
        ofType(SUCCESS_REQUEST_SUBMISSION),
        filter(({ response }) => get(response, 'confirmation.trigger_type') === 'rsvp-update'),
        map(() => setIsUpdating(false)),
    );

// --- Google Analytics Tracking --- //

export const onFormStartGAEpic = (action$, state$) =>
    action$.pipe(
        ofType(GA_FORM_START_EFFECT),
        filter(() => !getIsUserLoggedIn(state$.value)),
        filter(() => !getFormStarted(state$.value)),
        map(() => {
            window.gtag &&
                window.gtag('event', GA4_FORM_STARTED, {
                    event_category: GA4_EVENT_CATEGORY_RSVP,
                });
            return setFormStarted();
        }),
    );

export const onFormSuccessfullyFinishedGAEpic = (action$, state$) =>
    action$.pipe(
        ofType(GA_FORM_SUCCESSFULLY_FINISHED_EFFECT),
        filter(() => !getIsUserLoggedIn(state$.value)),
        map(() => {
            window.gtag &&
                window.gtag('event', GA4_FORM_SUBMITTED, {
                    event_category: GA4_EVENT_CATEGORY_RSVP,
                });
            return setFormCompleted();
        }),
    );

export const onFormErrorGAEpic = (action$, state$) =>
    action$.pipe(
        ofType(GA_FORM_ERROR_EFFECT),
        filter(() => !getIsUserLoggedIn(state$.value)),
        map(() => {
            window.gtag &&
                window.gtag('event', GA4_FORM_ERROR, {
                    event_category: GA4_EVENT_CATEGORY_RSVP,
                });
        }),
        ignoreElements(),
    );

export default combineEpics(
    formRenderer,
    onSubmitCloseModalEpic,
    onUpdatedSubmissionEpic,
    onFormStartGAEpic,
    onFormSuccessfullyFinishedGAEpic,
    onFormErrorGAEpic,
);
